// extracted by mini-css-extract-plugin
module.exports = {"container":"SolutionPro_container__xdoC_"};